import { render, staticRenderFns } from "./XDepartPanelDemo.vue?vue&type=template&id=2af07e79&scoped=true&"
import script from "./XDepartPanelDemo.vue?vue&type=script&lang=js&"
export * from "./XDepartPanelDemo.vue?vue&type=script&lang=js&"
import style0 from "./XDepartPanelDemo.vue?vue&type=style&index=0&id=2af07e79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af07e79",
  null
  
)

export default component.exports